import { useEffect, useState } from "react";
// @mui
import { Table, TableBody, TableContainer } from "@mui/material";
// routes

// _mock_
// components
import Scrollbar from "../../components/scrollbar";
import {
  emptyRows,
  TableEmptyRows,
  TableHeadCustom,
  TableNoData,
  TableSelectedAction,
  useTable,
} from "../../components/table";
// sections
import TableBodySkeleton from "src/components/table/TableBodySkeleton";
import { EnrollmentTableRow } from "./list";
import StudentTabContainer from "./sections/StudentTabContainer.section";

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { label: "Enrollment Number", align: "left" },
  { label: "Program Name", align: "left" },
  { label: "Date Of Enrollment", align: "left" },
  { label: "Assigned Teachers", align: "left" },
  { label: "Total Classes", align: "left" },

  { label: "No. of Classes Attended", align: "left" },

  { label: "No. of Classes Left", align: "left" },

  { label: "Status", align: "left" },
];

// ----------------------------------------------------------------------

export default function EnrollmentPage({ enrollments }) {
  const { dense, page, order, orderBy, rowsPerPage, selected, onSort } =
    useTable();

  const [tableData, setTableData] = useState({});

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (enrollments && enrollments.length > 0) {
      setTableData(enrollments);
    }
  }, [enrollments]);

  const denseHeight = dense ? 52 : 72;

  return (
    <>
      <StudentTabContainer title="Enrollments">
        <TableContainer sx={{ position: "relative", overflow: "unset", mt: 2 }}>
          <Scrollbar>
            <TableSelectedAction
              dense={dense}
              numSelected={selected.length}
              rowCount={tableData.length}
            />
            <Table size={dense ? "small" : "medium"} sx={{ minWidth: 800 }}>
              <TableHeadCustom
                order={order}
                orderBy={orderBy}
                headLabel={TABLE_HEAD}
                rowCount={tableData?.length}
                numSelected={selected?.length}
                onSort={onSort}
              />

              <TableBody>
                {enrollments &&
                  enrollments.map((i) => (
                    <EnrollmentTableRow key={enrollments} row={i} />
                  ))}

                <TableEmptyRows
                  height={denseHeight}
                  emptyRows={emptyRows(page, rowsPerPage, tableData.length)}
                />

                {isLoading && (
                  <TableBodySkeleton rows={10} columns={TABLE_HEAD.length} />
                )}

                <TableNoData />
              </TableBody>
            </Table>
          </Scrollbar>
        </TableContainer>
      </StudentTabContainer>
    </>
  );
}

// ----------------------------------------------------------------------
